// extracted by mini-css-extract-plugin
export default {"noScrollbar":"WorkspaceTabs_noScrollbar__kYTnS"};